<template>
  <v-app-bar class="bg-blue-1" style="height: 47px"  hide-on-scroll flat app>
    <v-container>
    <v-layout>
      <v-flex style="height: 35px">
        <a href="https://www.gov.co" target="_blank" >
          <v-img :src="path + 'img/logo_govco.svg'" class="gov-co-logo" ></v-img>
        </a>
      </v-flex>
    </v-layout>
  </v-container>
  </v-app-bar>
</template>


<script>
// 201906141938: Refresh data with timer
// https://stackoverflow.com/a/36572908
export default {
  name: "global-header",
  data: function() {
    return {
      date: "",
      timer: "",
      path: process.env.BASE_URL
    };
  },

};
</script>
